import AuthService from '../services/auth.service';

// El checkout anterior se retiró: todo usuario autenticado usa el nuevo (y sus
// reglas asociadas, como el upselling sin repetidos). El backend aplica lo mismo
// en cada operación (lib/newCheckout/access.js), así que ya no se consulta
// GET /new-checkout-access; se mantienen las funciones para no tocar a quienes
// las usan.

// true si hay usuario; null si no hay sesión.
export function getCachedNewCheckoutAccess() {
  return AuthService.getCurrentUser() ? true : null;
}

export function resolveNewCheckoutAccess() {
  return Promise.resolve(!!AuthService.getCurrentUser());
}
